export default "__VITE_ASSET__cd2f1b07__"